import axios from "axios";
import { HttpCodes, studyStatusOptions } from "../../../modules/constants";
import { handleHttpErrors } from "../../../modules/http";

const SET_SITES = "SET_SITES";
const EMAIL_EXISTS = "EMAIL_EXISTS";
const RESET_EMAIL_EXISTS = "RESET_EMAIL_EXISTS";

const getSites = (state) => state.sites;
const getEmailExists = (state) => state.emailExists;

const initialState = {
  sites: [],
  emailExists: undefined,
};

export const addUserAccessManagementReducer = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case SET_SITES:
      const { sites } = action;

      return {
        ...state,
        sites,
      };
    case EMAIL_EXISTS:
      return {
        ...state,
        emailExists: action.emailExists,
      };
    case RESET_EMAIL_EXISTS:
      return {
        ...state,
        emailExists: undefined,
      };
    default:
      return state;
  }
};

export const inviteAdminUser =
  (email, roleName, study, sites) => (dispatch, getState) => {
    return axios
      .post(`/api/account/management/invite`, {
        Email: email,
        Rolename: roleName,
        study: study,
        sites: sites,
      })
      .then(() => {
        return Promise.resolve("User invited successfully!");
      })
      .catch((error) => {
        return handleHttpErrors(error.request?.status, {
          default: "There was an error while trying to invite the user!",
          conflict: "The email address you have entered is already registered.",
          preConditionFailed:
            "This email is not whitelisted. Please contact IT.",
        });
      });
  };

export const updateAdminUser =
  (id, username, roleName, study, sites) => (dispatch, getState) => {
    return axios
      .put(`/api/account/management/update`, {
        adminUserID: id,
        username: username,
        rolename: roleName,
        study: study,
        sites: sites,
      })
      .then(() => {
        return Promise.resolve("An email was sent. User updated successfully!");
      })
      .catch((error) => {
        return handleHttpErrors(error.request?.status, {
          default:
            error?.response?.data ??
            "There was an error while trying to update the user!",
        });
      });
  };

export const updateUserData = (userid, study) => (dispatch, getState) => {
  return axios
    .post(`/api/study/enroll`, {
      study: study,
      ParticipantID: userid,
      Status: studyStatusOptions.SCREENING.id,
    })
    .then(() => {
      return Promise.resolve("An email was sent. User updated successfully!");
    })
    .catch((error) => {
      return handleHttpErrors(error.request?.status, {
        default: "There was an error while trying to update the user!",
      });
    });
};

export const fetchSites = (studyId) => (dispatch, getState) => {
  const params = {
    studyId: studyId,
  };

  return axios
    .get(`/api/study/sites`, { params })
    .then(({ data }) => {
      const sites = data?.sort((a, b) => {
        return a.name.localeCompare(b.name);
      });
      dispatch({ type: SET_SITES, sites: sites });
    })
    .catch(() => {});
};

export const checkIfEmailExists = (email) => (dispatch, getState) => {
  const params = {
    email: email,
  };

  return axios
    .get(`/api/account/emailexists`, {
      params,
    })
    .then(() => {
      dispatch({ type: EMAIL_EXISTS, emailExists: false });
    })
    .catch((error) => {
      if (error?.response?.status === HttpCodes.CONFLICT) {
        dispatch({ type: EMAIL_EXISTS, emailExists: true });
      }
    });
};

export const resetEmailExists = () => (dispatch, getState) => {
  dispatch({ type: RESET_EMAIL_EXISTS });
};

export const mapStateToProps = (state) => {
  return {
    sites: getSites(state),
    emailExists: getEmailExists(state),
  };
};

export const mapDispatchToProps = {
  inviteAdminUser,
  updateAdminUser,
  updateUserData,
  fetchSites,
  checkIfEmailExists,
  resetEmailExists,
};
